<template>
  <div
    v-if="isShow && isChinese()"
    class="user-verify-tag"
    :class="{
      'cursor-pointer': isHover,
      [colors]: colors,
    }"
    @click="goLink"
  >
    <div>{{ statusText }}</div>
  </div>
</template>

<script lang="ts" setup>
import { PAGE_ACTION_KEYS } from '@rendora/common/entities/app_cfg';
import { USER_LEVEL_KEY, type UserInfo, type UserVerifyInfo } from '~/api/interface';
import { USER_VERIFY_MAP, USER_VERIFY_STATUS } from '~/constants';
import { PageKey } from '~/constants/page';
const { $t } = useNuxtApp();

const { hasActionPermission } = usePageAndActionPermissionData();

const props = defineProps<{
  data?: UserInfo | UserVerifyInfo | any;
  status?: USER_VERIFY_STATUS;
  disabled?: boolean;
}>();

const isShow: any = computed(
  () =>
    ![USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
      Number(props.data?.rights_type),
    ) && hasActionPermission(PAGE_ACTION_KEYS.CENTER_ACCOUNT_CHANGE_VERIFY_INFO),
);

const statusText: any = computed(() => USER_VERIFY_MAP()[props.status!] || $t('wei-ren-zheng'));

const isHover: any = computed(
  () => !props.disabled && props?.status !== USER_VERIFY_STATUS.SUCCESS,
);

const colors: any = computed(() =>
  props?.status === USER_VERIFY_STATUS.SUCCESS
    ? 'success'
    : props?.status === USER_VERIFY_STATUS.WAIT
      ? 'wait'
      : '',
);

const goLink = () => {
  // 海外需要隐藏所有认证入口
  if (isGlobalVersion()) {
    return;
  }

  if (props.disabled) {
    return;
  }

  if (props?.status === USER_VERIFY_STATUS.SUCCESS) {
    return;
  }

  const router = useRouter();
  router.push({
    name: PageKey.ACCOUNT_VERIFY,
  });
};
</script>

<style lang="scss" scoped>
.user-verify-tag {
  @apply rounded-[6px] min-w-[46px] h-[20px] text-font-60 text-[12px] flex-y-center justify-center bg-back-5 px-[5px];
}
.success {
  @apply bg-[#C4F1E8] text-[#00B990];
}
.wait {
  @apply bg-[#E9ECFF] text-primary;
}
</style>
